<template>
  <v-app>

    <TopBar />

    <v-main class="maincont">

      <Temps v-if="view == 'temps'" />
      <Analisi v-if="view == 'analisi'" />
      <Mapes v-if="view == 'mapes'" />
      <Dades v-if="view == 'dades'" />

    </v-main>

    <BottomNav />
    <ErrorNotify />

  </v-app>
</template>

<script>
 import ErrorNotify from './components/ErrorNotify';
 import BottomNav from './components/BottomNav';
 import TopBar from './components/TopBar';
 import Temps from './components/Temps';
 import Analisi from './components/Analisi';
 import Mapes from './components/Mapes';
 import Dades from './components/Dades';
 import { mapState, mapActions, mapMutations } from 'vuex';

 export default {
   name: 'App',

   components: {
     ErrorNotify,
     BottomNav,
     TopBar,
     Temps,
     Analisi,
     Mapes,
     Dades,
   },

   data: () => ({
     //
   }),

   created() {
     // Fetch API data
     if (!this.last)
       this.LOAD_LAST();
     if (!this.prediction)
       this.LOAD_PREDICTION();
   },

   computed: {
     ...mapState([
       'meteo',
       'headers',
       'prediction',
       'last',
     ]),

     view() {
       const url_parts = this.$route.path.split('/');
       return url_parts[1] || (url_parts[0].length > 3 ? url_parts[0] : 'temps');
     },
   },

   methods: {
     ...mapActions([
       'LOAD_TABLE',
       'LOAD_HEADERS',
       'LOAD_PREDICTION',
       'LOAD_LAST',
     ]),
     ...mapMutations(['SET_ERROR']),
   },
 };
</script>

<style scoped>
 #app {
   background-color: #f2e6e8;
 }
 .maincont {
   margin-top: 1em;
   margin-bottom: 4em;
 }
</style>
